module.exports = __webpack_public_path__ + "img/513.17338559.png";